import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { RuleDetailsRowData } from "../utils/historyRuleDetailsRows";
import styles from "../HistoryRuleDetails.module.scss";
import { RelativeDateCell } from "../../cells/RelativeDateCell";

export const RuleDetailsTimeCell = memo(
    ({ row }: { row: { original: RuleDetailsRowData } }) => (
        <ViewTableCell className={styles.tdTime}>
            <RelativeDateCell row={row} dateField="logDate" />
        </ViewTableCell>
    ),
);

RuleDetailsTimeCell.displayName = "RuleDetailsTimeCell";
